import React from 'react'

const UserAvatar = ({ name, email, src, className = 'w-12 h-12', neutral = false }) => {
  const getInitials = (name) => {
    if (!name) return '?'
    const parts = name.split(' ').filter(Boolean)
    if (parts.length === 0) return '?'
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
  }

  // If we have a real src (not a placeholder), use it
  if (src && !src.includes('dicebear.com')) {
    return (
      <img
        src={src}
        alt={name || 'User Avatar'}
        className={`${className} rounded-full object-cover`}
      />
    )
  }

  const initials = getInitials(name || email)

  // Design system: one accent tint for every avatar (no per-user rainbow); "neutral" is the sidebar user block
  const tone = neutral ? 'bg-slate-200 text-slate-600' : 'bg-accent text-primary'

  return (
    <div className={`${className} ${tone} rounded-full flex items-center justify-center font-semibold uppercase flex-shrink-0`}>
      <span className={className.includes('w-12') ? 'text-lg' : 'text-xs'}>
        {initials}
      </span>
    </div>
  )
}

export default UserAvatar
